const reviews = [
  {
    name: "Rachel T.",
    location: "University District, Missoula, MT",
    rating: 5,
    text: "Our family trip to Italy almost fell through when we realized the kids' passports were expired. Fast Passport Center had four renewals processed in 8 days. The relief was indescribable. Thank you!",
    service: "Family Renewal",
  },
  {
    name: "Chris A.",
    location: "Rattlesnake, Missoula, MT",
    rating: 5,
    text: "I'd been putting off renewing forever. When I finally needed it urgently for a work trip, these folks sorted me out without any panic. My agent was responsive, knowledgeable, and kept me completely updated.",
    service: "Expedited Renewal",
  },
  {
    name: "Diane H.",
    location: "Lolo, MT",
    rating: 5,
    text: "Missoula to Denver and back would have been a nightmare and cost more than the passport itself. Fast Passport Center made the whole thing a total non-event. Documents shipped, passport arrived. Done.",
    service: "Standard Expedited",
  },
];

export default function TestimonialsSection() {
  return (
    <section id="reviews" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Missoula Travelers Are Saying
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base">
            Real customers. Real results. No agency trip required.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {reviews.map((r, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-7 flex flex-col">
              <div className="flex items-center gap-0.5 mb-4">
                {Array.from({ length: r.rating }).map((_, j) => (
                  <i key={j} className="ri-star-fill text-[#F6C344] text-sm"></i>
                ))}
              </div>
              <p className="text-gray-600 text-sm leading-relaxed mb-6 flex-1">&ldquo;{r.text}&rdquo;</p>
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{r.name}</p>
                  <p className="text-gray-400 text-xs">{r.location}</p>
                </div>
                <span className="bg-[#EEF2F8] text-[#1A365D] text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                  {r.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}